module.exports = __webpack_public_path__ + "img/icons8-buick.7bdc4ddd.svg";